var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 112,
    height: 112,
    rx: 56,
    fill: "#42307D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1124_12857)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7734 24.3961L52.3359 14.5028L68.9436 24.3961H68.9436L85.5512 34.2894L68.9436 44.1361L52.3359 34.2894H52.3359L35.7734 24.3961ZM77.2266 88.6097L93.8342 78.7632V58.9763L77.2266 68.8697V88.6097ZM44.0566 68.869V88.6089L60.6621 98.5011V98.5024L60.6632 98.5017L60.6643 98.5024V98.5011L77.2246 88.6089V68.869L60.6632 78.7618L44.0566 68.869ZM85.5549 54.0295L68.9473 63.9228V44.1361L85.5549 34.2894V54.0295ZM19.168 44.1366V63.9215V63.9232V83.7081L35.7756 93.5548V73.8166V73.8149V54.0299L19.168 44.1366ZM52.3381 44.1361L35.7756 34.2894L19.168 44.1361L35.7756 54.0295L52.3381 44.1361Z",
    fill: "#9E77ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1124_12857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white",
    transform: "translate(14.5 14.5013)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLend);
export default __webpack_public_path__ + "static/media/lend.ff047eb80b685c34d367e3fc1b48fa07.svg";
export { ForwardRef as ReactComponent };